// Generated from CraftPix Dungeon1.tmx
export const DUNGEON_CRAFTPIX_DATA = {
  "torches": [
    {
      "x": 435,
      "y": 435
    },
    {
      "x": 465,
      "y": 435
    },
    {
      "x": 435,
      "y": 465
    },
    {
      "x": 465,
      "y": 465
    },
    {
      "x": 495,
      "y": 435
    },
    {
      "x": 525,
      "y": 435
    },
    {
      "x": 495,
      "y": 465
    },
    {
      "x": 525,
      "y": 465
    },
    {
      "x": 1095,
      "y": 345
    },
    {
      "x": 1125,
      "y": 345
    },
    {
      "x": 1095,
      "y": 375
    },
    {
      "x": 1125,
      "y": 375
    },
    {
      "x": 1185,
      "y": 375
    },
    {
      "x": 1215,
      "y": 375
    },
    {
      "x": 1095,
      "y": 405
    },
    {
      "x": 1125,
      "y": 405
    },
    {
      "x": 1185,
      "y": 405
    },
    {
      "x": 1215,
      "y": 405
    },
    {
      "x": 435,
      "y": 495
    },
    {
      "x": 465,
      "y": 495
    },
    {
      "x": 495,
      "y": 495
    },
    {
      "x": 525,
      "y": 495
    },
    {
      "x": 615,
      "y": 525
    },
    {
      "x": 645,
      "y": 525
    },
    {
      "x": 675,
      "y": 525
    },
    {
      "x": 615,
      "y": 555
    },
    {
      "x": 645,
      "y": 555
    },
    {
      "x": 675,
      "y": 555
    },
    {
      "x": 615,
      "y": 585
    },
    {
      "x": 645,
      "y": 585
    },
    {
      "x": 675,
      "y": 585
    },
    {
      "x": 915,
      "y": 675
    },
    {
      "x": 945,
      "y": 675
    },
    {
      "x": 915,
      "y": 705
    },
    {
      "x": 945,
      "y": 705
    },
    {
      "x": 915,
      "y": 735
    },
    {
      "x": 945,
      "y": 735
    },
    {
      "x": 945,
      "y": 765
    },
    {
      "x": 585,
      "y": 795
    },
    {
      "x": 615,
      "y": 795
    },
    {
      "x": 945,
      "y": 795
    },
    {
      "x": 585,
      "y": 825
    },
    {
      "x": 615,
      "y": 825
    },
    {
      "x": 825,
      "y": 825
    },
    {
      "x": 855,
      "y": 825
    },
    {
      "x": 945,
      "y": 825
    },
    {
      "x": 585,
      "y": 855
    },
    {
      "x": 615,
      "y": 855
    },
    {
      "x": 825,
      "y": 855
    },
    {
      "x": 855,
      "y": 855
    },
    {
      "x": 1065,
      "y": 525
    },
    {
      "x": 1095,
      "y": 525
    },
    {
      "x": 1125,
      "y": 525
    },
    {
      "x": 1065,
      "y": 555
    },
    {
      "x": 1095,
      "y": 555
    },
    {
      "x": 1125,
      "y": 555
    },
    {
      "x": 1065,
      "y": 585
    },
    {
      "x": 1095,
      "y": 585
    },
    {
      "x": 1125,
      "y": 585
    },
    {
      "x": 975,
      "y": 675
    },
    {
      "x": 1365,
      "y": 675
    },
    {
      "x": 1395,
      "y": 675
    },
    {
      "x": 975,
      "y": 705
    },
    {
      "x": 1365,
      "y": 705
    },
    {
      "x": 1395,
      "y": 705
    },
    {
      "x": 975,
      "y": 735
    },
    {
      "x": 975,
      "y": 765
    },
    {
      "x": 1005,
      "y": 765
    },
    {
      "x": 975,
      "y": 795
    },
    {
      "x": 1005,
      "y": 795
    },
    {
      "x": 975,
      "y": 825
    },
    {
      "x": 1005,
      "y": 825
    },
    {
      "x": 1275,
      "y": 915
    },
    {
      "x": 1305,
      "y": 915
    },
    {
      "x": 1275,
      "y": 945
    },
    {
      "x": 1305,
      "y": 945
    },
    {
      "x": 585,
      "y": 1005
    },
    {
      "x": 615,
      "y": 1005
    },
    {
      "x": 885,
      "y": 1005
    },
    {
      "x": 915,
      "y": 1005
    },
    {
      "x": 945,
      "y": 1005
    },
    {
      "x": 585,
      "y": 1035
    },
    {
      "x": 615,
      "y": 1035
    },
    {
      "x": 885,
      "y": 1035
    },
    {
      "x": 915,
      "y": 1035
    },
    {
      "x": 945,
      "y": 1035
    },
    {
      "x": 885,
      "y": 1065
    },
    {
      "x": 915,
      "y": 1065
    },
    {
      "x": 945,
      "y": 1065
    },
    {
      "x": 1395,
      "y": 1065
    },
    {
      "x": 1425,
      "y": 1065
    },
    {
      "x": 1395,
      "y": 1095
    },
    {
      "x": 1425,
      "y": 1095
    },
    {
      "x": 1395,
      "y": 1125
    },
    {
      "x": 1425,
      "y": 1125
    }
  ],
  "traps": [
    {
      "x": 1065,
      "y": 435
    },
    {
      "x": 1095,
      "y": 435
    },
    {
      "x": 1065,
      "y": 465
    },
    {
      "x": 1095,
      "y": 465
    },
    {
      "x": 555,
      "y": 585
    },
    {
      "x": 765,
      "y": 585
    },
    {
      "x": 795,
      "y": 585
    },
    {
      "x": 825,
      "y": 585
    },
    {
      "x": 555,
      "y": 615
    },
    {
      "x": 795,
      "y": 615
    },
    {
      "x": 795,
      "y": 645
    },
    {
      "x": 765,
      "y": 675
    },
    {
      "x": 795,
      "y": 675
    },
    {
      "x": 825,
      "y": 675
    },
    {
      "x": 1005,
      "y": 615
    },
    {
      "x": 1005,
      "y": 645
    },
    {
      "x": 1125,
      "y": 825
    },
    {
      "x": 1155,
      "y": 825
    },
    {
      "x": 1125,
      "y": 855
    },
    {
      "x": 1155,
      "y": 855
    },
    {
      "x": 645,
      "y": 1035
    },
    {
      "x": 675,
      "y": 1035
    },
    {
      "x": 645,
      "y": 1065
    },
    {
      "x": 675,
      "y": 1065
    },
    {
      "x": 1005,
      "y": 975
    },
    {
      "x": 1035,
      "y": 975
    },
    {
      "x": 1005,
      "y": 1005
    },
    {
      "x": 1035,
      "y": 1005
    },
    {
      "x": 1275,
      "y": 1035
    },
    {
      "x": 1305,
      "y": 1035
    },
    {
      "x": 1335,
      "y": 1035
    },
    {
      "x": 1275,
      "y": 1065
    },
    {
      "x": 1305,
      "y": 1065
    },
    {
      "x": 1335,
      "y": 1065
    },
    {
      "x": 1275,
      "y": 1095
    },
    {
      "x": 1305,
      "y": 1095
    },
    {
      "x": 1335,
      "y": 1095
    }
  ],
  "objects": [
    {
      "x": 795,
      "y": 435
    },
    {
      "x": 825,
      "y": 435
    },
    {
      "x": 855,
      "y": 435
    },
    {
      "x": 795,
      "y": 465
    },
    {
      "x": 825,
      "y": 465
    },
    {
      "x": 855,
      "y": 465
    },
    {
      "x": 1005,
      "y": 375
    },
    {
      "x": 1215,
      "y": 375
    },
    {
      "x": 1245,
      "y": 375
    },
    {
      "x": 1005,
      "y": 405
    },
    {
      "x": 1035,
      "y": 405
    },
    {
      "x": 1095,
      "y": 405
    },
    {
      "x": 1185,
      "y": 405
    },
    {
      "x": 1215,
      "y": 405
    },
    {
      "x": 1245,
      "y": 405
    },
    {
      "x": 1005,
      "y": 435
    },
    {
      "x": 1035,
      "y": 435
    },
    {
      "x": 1095,
      "y": 435
    },
    {
      "x": 1155,
      "y": 435
    },
    {
      "x": 1185,
      "y": 435
    },
    {
      "x": 1215,
      "y": 435
    },
    {
      "x": 1245,
      "y": 435
    },
    {
      "x": 1005,
      "y": 465
    },
    {
      "x": 1335,
      "y": 465
    },
    {
      "x": 1395,
      "y": 465
    },
    {
      "x": 1425,
      "y": 465
    },
    {
      "x": 435,
      "y": 795
    },
    {
      "x": 435,
      "y": 915
    },
    {
      "x": 435,
      "y": 945
    },
    {
      "x": 795,
      "y": 495
    },
    {
      "x": 825,
      "y": 495
    },
    {
      "x": 855,
      "y": 495
    },
    {
      "x": 945,
      "y": 495
    },
    {
      "x": 555,
      "y": 525
    },
    {
      "x": 585,
      "y": 525
    },
    {
      "x": 615,
      "y": 525
    },
    {
      "x": 795,
      "y": 525
    },
    {
      "x": 825,
      "y": 525
    },
    {
      "x": 855,
      "y": 525
    },
    {
      "x": 945,
      "y": 525
    },
    {
      "x": 555,
      "y": 555
    },
    {
      "x": 585,
      "y": 555
    },
    {
      "x": 615,
      "y": 555
    },
    {
      "x": 705,
      "y": 555
    },
    {
      "x": 885,
      "y": 555
    },
    {
      "x": 495,
      "y": 585
    },
    {
      "x": 525,
      "y": 585
    },
    {
      "x": 705,
      "y": 585
    },
    {
      "x": 885,
      "y": 585
    },
    {
      "x": 495,
      "y": 615
    },
    {
      "x": 525,
      "y": 615
    },
    {
      "x": 555,
      "y": 735
    },
    {
      "x": 825,
      "y": 735
    },
    {
      "x": 825,
      "y": 765
    },
    {
      "x": 795,
      "y": 855
    },
    {
      "x": 825,
      "y": 855
    },
    {
      "x": 855,
      "y": 855
    },
    {
      "x": 885,
      "y": 855
    },
    {
      "x": 795,
      "y": 885
    },
    {
      "x": 825,
      "y": 885
    },
    {
      "x": 855,
      "y": 885
    },
    {
      "x": 885,
      "y": 885
    },
    {
      "x": 525,
      "y": 915
    },
    {
      "x": 825,
      "y": 915
    },
    {
      "x": 525,
      "y": 945
    },
    {
      "x": 825,
      "y": 945
    },
    {
      "x": 885,
      "y": 945
    },
    {
      "x": 945,
      "y": 945
    },
    {
      "x": 975,
      "y": 495
    },
    {
      "x": 1335,
      "y": 495
    },
    {
      "x": 1395,
      "y": 495
    },
    {
      "x": 1425,
      "y": 495
    },
    {
      "x": 975,
      "y": 525
    },
    {
      "x": 1065,
      "y": 675
    },
    {
      "x": 1065,
      "y": 705
    },
    {
      "x": 1035,
      "y": 765
    },
    {
      "x": 1305,
      "y": 765
    },
    {
      "x": 1335,
      "y": 765
    },
    {
      "x": 1395,
      "y": 765
    },
    {
      "x": 1425,
      "y": 765
    },
    {
      "x": 1035,
      "y": 795
    },
    {
      "x": 1185,
      "y": 795
    },
    {
      "x": 1215,
      "y": 795
    },
    {
      "x": 1305,
      "y": 795
    },
    {
      "x": 1335,
      "y": 795
    },
    {
      "x": 1395,
      "y": 795
    },
    {
      "x": 1425,
      "y": 795
    },
    {
      "x": 1185,
      "y": 825
    },
    {
      "x": 1215,
      "y": 825
    },
    {
      "x": 1125,
      "y": 945
    },
    {
      "x": 1305,
      "y": 945
    },
    {
      "x": 1335,
      "y": 945
    },
    {
      "x": 1365,
      "y": 945
    },
    {
      "x": 1455,
      "y": 675
    },
    {
      "x": 1455,
      "y": 705
    },
    {
      "x": 825,
      "y": 975
    },
    {
      "x": 945,
      "y": 975
    },
    {
      "x": 735,
      "y": 1005
    },
    {
      "x": 765,
      "y": 1005
    },
    {
      "x": 825,
      "y": 1005
    },
    {
      "x": 735,
      "y": 1035
    },
    {
      "x": 765,
      "y": 1035
    },
    {
      "x": 825,
      "y": 1035
    },
    {
      "x": 615,
      "y": 1065
    },
    {
      "x": 735,
      "y": 1065
    },
    {
      "x": 765,
      "y": 1065
    },
    {
      "x": 615,
      "y": 1095
    },
    {
      "x": 1125,
      "y": 975
    },
    {
      "x": 1185,
      "y": 975
    },
    {
      "x": 1305,
      "y": 975
    },
    {
      "x": 1335,
      "y": 975
    },
    {
      "x": 1365,
      "y": 975
    },
    {
      "x": 1305,
      "y": 1005
    },
    {
      "x": 1335,
      "y": 1005
    },
    {
      "x": 975,
      "y": 1065
    },
    {
      "x": 1155,
      "y": 1065
    },
    {
      "x": 1185,
      "y": 1065
    },
    {
      "x": 975,
      "y": 1095
    },
    {
      "x": 1155,
      "y": 1095
    },
    {
      "x": 1185,
      "y": 1095
    },
    {
      "x": 1275,
      "y": 1125
    },
    {
      "x": 1305,
      "y": 1125
    },
    {
      "x": 1335,
      "y": 1125
    },
    {
      "x": 1485,
      "y": 1035
    },
    {
      "x": 1485,
      "y": 1065
    },
    {
      "x": 1485,
      "y": 1095
    },
    {
      "x": 1485,
      "y": 1125
    }
  ]
};

if (typeof window !== 'undefined') { window.DungeonCraftPixData = DUNGEON_CRAFTPIX_DATA; }
